<script setup>
import Newsletter from '~/components/forms/generics/Newsletter.vue'
import {useConfigStore} from '~/store/config'

const configStore = useConfigStore()
const currentYear = computed(() => new Date().getFullYear())

const footerMenuItems = computed(() => configStore.getMenuItems('footer_left'))
const contactData = computed(() => configStore.contactData)
const cleanPhone = computed(() => contactData.value.phone.replace(/\s/g, ''))
const cleanPhoneAlt = computed(() => contactData.value.phoneAlt.replace(/\s/g, ''))
</script>

<template>
  <div class="grid grid-cols-12 gap-4 px-4 bg-[#363330] text-white pt-12">
    <div class="col-span-12 xl:col-span-4 text-center mb-8">
      <h5 class="uppercase font-bold italic text-lg mb-3">Información general</h5>
      <ul>
        <li v-for="item in footerMenuItems" :key="item.id">
          <NuxtLink class="hover:underline text-[0.8rem] italic" :to="item.url">
            {{ item.label }}
          </NuxtLink>
        </li>
      </ul>
    </div>
    <div class="col-span-12 xl:col-span-4 text-center mb-8">
      <h5 class="uppercase font-bold italic text-lg mb-3">Datos de Contacto</h5>
      <ul>
        <li class="text-[0.8rem] italic">
          <i class="pi pi-map-marker mr-2"></i>
          <span>{{ contactData.address }}</span>
        </li>
        <li class="text-[0.8rem] italic my-2">
          <i class="pi pi-phone mr-2"></i>
          <a :href="`tel:${cleanPhone}`">{{ contactData.phone }}</a>
          <span v-if="contactData.phoneAlt" class="px-1">|</span>
          <a v-if="contactData.phoneAlt" :href="`tel:${cleanPhoneAlt}`">{{ contactData.phoneAlt }}</a>
        </li>
      </ul>
      <div class="flex justify-center">
        <a v-if="contactData.facebookLink" :href="contactData.facebookLink" target="_blank">
          <i class="pi pi-facebook font-[1.5rem]"/>
        </a>
        <a v-if="contactData.instagramLink" class="mx-4" :href="contactData.instagramLink" target="_blank">
          <i class="pi pi-instagram font-[1.5rem]"/>
        </a>
        <a v-if="contactData.youtubeLink" :href="contactData.youtubeLink" target="_blank">
          <i class="pi pi-youtube font-[1.5rem]"/>
        </a>
      </div>
    </div>
    <div class="col-span-12 xl:col-span-4 text-center mb-8">
      <h5 class="uppercase font-bold italic text-lg mb-3">Horario</h5>
      <div v-html="contactData.scheduleTable" class="text-[0.8rem] italic flex flex-col gap-2"></div>
    </div>
    <!--<div class="col-span-12 mb-12">
      <iframe class="w-full"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3170.231941959349!2d-6.011394523864423!3d37.384346734553795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd126c6bf1e9b20f%3A0x168f910f4320e139!2sCarmen%20Olmedo%20Estilismo%20y%20Peluquer%C3%ADa!5e0!3m2!1ses!2ses!4v1694010225046!5m2!1ses!2ses"
              width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>-->


    <div class="col-span-12 my-5">
      <Newsletter/>
    </div>

    <div class="col-span-12 grid grid-cols-12 gap-2 mt-8 mb-12 text-xs italic">
      <div class="col-span-12 sm:col-span-6 text-center sm:text-right">
        {{ contactData.tradeName }}. Copyright ©{{ currentYear }}.
      </div>
      <div class="col-span-12 sm:col-span-6 text-center sm:text-left">
        Todos los derechos reservados.
      </div>
    </div>
  </div>
</template>
